<script>
    const styleElFormSize='mini';
    const styleTableSize='mini';
    const pageSizes=[10,15,20,30,40,50];
    const loadingParam={
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    };
    export default
    {
        styleElFormSize,
        styleTableSize,
        pageSizes,
        loadingParam
    }
</script>


// WEBPACK FOOTER //
// src/global/globlaconfig.vue